import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeDetailsModule } from '../employee-details/employee-details.module';
import { ProductsModule } from '../products/products.module';
import { SupplierRepo } from './dto/supplier.repositry';
import { SuppliersAdapter } from './dto/suppliers.adapter';
import { Farm } from './farms.entity';
import { Supplier } from './supplier.entity';
import { SuppliersController } from './suppliers.controller';
import { SuppliersService } from './suppliers.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Farm, SupplierRepo]),
    ProductsModule,
    EmployeeDetailsModule
  ],
  controllers: [SuppliersController],
  providers: [SuppliersService, ApplicationExceptionHandler, SuppliersAdapter,LogsService]
})
export class SuppliersModule { }
